import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import { Main } from "../../MUIStyled/Main";
import { DrawerHeader } from "../../MUIStyled/DrawerHeader";
import { photoLocations } from "../../../../config/360photos";
import { stormScenarios } from "../../../../config/stormScenarios";
import CustomImgPopup from "../../Photos/CustomImgPopup";
import WebMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Locate from "@arcgis/core/widgets/Locate.js";
import LayerList from "@arcgis/core/widgets/LayerList";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";
import _ from "lodash";
import "../Maps.css";

let photoLocationsLayerView;

const CompareTwoScenariosMapContainer = ({
 open,
 checked,
 mapExtent,
 setMapExtent,
 reductionState,
}) => {
 const mapRef = useRef();

 const [theMap, setMap] = useState();
 const [mapView, setMapView] = useState();
 const [photoLocationsLayer, setPhotoLocationsLayer] = useState();

 const [resultantArray, setResultantArray] = useState([]);

 // state variables
 const scenarioTwo = useSelector((state) => state.scenarioTwo.scenarioTwo);

 // adaptationSelection
 useEffect(() => {
  if (!!reductionState["selectedAdaption"] && reductionState["availableSLR"]) {
   let availableSLR = reductionState["availableSLR"].map((slr) => slr.title);
   setResultantArray(availableSLR);
  }
 }, [reductionState["selectedAdaption"], reductionState["availableSLR"]]);

 // slrSelection
 useEffect(() => {
  if (!!reductionState["selectedSLR"] && reductionState["availableRain"]) {
   let availableRain = reductionState["availableRain"].map(
    (rain) => rain.title
   );
   setResultantArray(availableRain);
  }
 }, [reductionState["selectedSLR"], reductionState["availableRain"]]);

 // rainfallSelection
 useEffect(() => {
  if (
   !!reductionState["selectedRainfallAmount"] &&
   reductionState["availableStormSurges"]
  ) {
   let availableStormSurges = reductionState["availableStormSurges"].map(
    (ss) => ss.title
   );
   setResultantArray(availableStormSurges);
  }
 }, [
  reductionState["selectedRainfallAmount"],
  reductionState["availableStormSurges"],
 ]);

 // stormSurgeSelection
 useEffect(() => {
  if (
   !!reductionState["selectedStormSurge"] &&
   reductionState["availableGroundwater"]
  ) {
   let availableGW = reductionState["availableGroundwater"].map(
    (gw) => gw.title
   );
   setResultantArray(availableGW);
  }
 }, [
  reductionState["selectedStormSurge"],
  reductionState["availableGroundwater"],
 ]);

 // groudwaterSelection
 useEffect(() => {
  if (
   !!reductionState["selectedGroundwaterConditions"] &&
   !!reductionState["finalSelection"]
  ) {
   let finalSelection = reductionState["finalSelection"].map((fs) => fs.title);
   setResultantArray(finalSelection);
  }
 }, [
  reductionState["selectedGroundwaterConditions"],
  reductionState["finalSelection"],
 ]);

 const getImage = (title) => {
  // create a popup template
  const popupTemplate = {
   title: `${title}`,
   // type: "media",
   content: (event) => {
    const container = document.createElement("div");
    container.className = "photo-360-container";

    // get the location title from the "Name" attribute
    const locationTitle = event.graphic.attributes["Name"];

    // create a div to render the React component into
    const reactContainer = document.createElement("div");

    // get the baseline photo
    let gallery = [photoLocations[locationTitle]["baseline"]["url"]];

    // filter the storm scenarios that match the current state
    let filteredScenarios = stormScenarios.filter((scenario) => {
     if (
      !!scenarioTwo?.rainfall &&
      !!scenarioTwo?.slr &&
      !!scenarioTwo?.surge &&
      !!scenarioTwo?.groundwater
     ) {
      return (
       scenario.rainfallAmount === scenarioTwo?.rainfall &&
       scenario.SLR === scenarioTwo?.slr &&
       scenario.stormSurge === scenarioTwo?.surge &&
       scenario.groudwaterConditions === scenarioTwo?.groundwater
      );
     } else if (
      !!scenarioTwo?.rainfall &&
      !!scenarioTwo?.slr &&
      !!scenarioTwo?.surge
     ) {
      return (
       scenario.rainfallAmount === scenarioTwo?.rainfall &&
       scenario.SLR === scenarioTwo?.slr &&
       scenario.stormSurge === scenarioTwo?.surge
      );
     } else {
      return null;
     }
    });

    filteredScenarios?.forEach((scenario) => {
     if (
      !!photoLocations[locationTitle] &&
      !!photoLocations[locationTitle]["scenario"] &&
      !!photoLocations[locationTitle]["scenario"][scenario.title] &&
      !!photoLocations[locationTitle]["scenario"][scenario.title]["url"]
     ) {
      gallery.push(
       photoLocations[locationTitle]["scenario"][scenario.title]["url"]
      );
     }
    });

    // Render the CustomImgPopup component into the reactContainer
    ReactDOM.render(
     <CustomImgPopup feature={event.graphic} newSRC={gallery} />,
     reactContainer
    );

    // Check if the container has been mounted before appending
    if (!!container) {
     container.appendChild(reactContainer);
    }

    return container;
   },
  };

  return popupTemplate;
 };

 useEffect(() => {
  if (mapRef.current) {
   const map = new WebMap({
    basemap: "gray-vector",
   });

   setMap(map);
   // load the map view at the ref's DOM node
   const mapview = new MapView({
    container: mapRef.current,
    map: map,
    center: [-80.15, 26.15],
    zoom: 11,
   });
   setMapView(mapview);

   mapview.when(() => {
    const customSymbolRenderer = {
     type: "simple",
     symbol: {
      type: "picture-marker",
      url: "/photo-symbol.png",
      width: "23.5px",
      height: "23.5px",
     },
    };

    // add 360 photo locations layer
    let photoLocationsLayer = new FeatureLayer({
     url: "https://services3.arcgis.com/Pn95KPPz613AKHXi/ArcGIS/rest/services/Photo360Locations/FeatureServer",
     outFields: ["*"],
     renderer: customSymbolRenderer,
     legendEnabled: false,
    });

    setPhotoLocationsLayer(photoLocationsLayer);

    // add scenarios to the map
    stormScenarios.forEach((scenario, idx) => {
     let tileLayer = new TileLayer({
      url: scenario["tileURL"],
      opacity: 0.4,
      visible: false,
     });
     map.add(tileLayer);
    });

    // add photo locations after scenarios
    map.add(photoLocationsLayer);

    let basemapGallery = new BasemapGallery({
     view: mapview,
    });

    const legendWidget = new Legend({
     view: mapview,
    });

    mapview.ui.add(
     new Expand({
      content: basemapGallery,
      expanded: false,
      expandTooltip: "Toggle Layers",
      view: mapview,
     }),
     "top-right"
    );

    mapview.ui.add(
     new Expand({
      content: legendWidget,
      expanded: false,
      expandTooltip: "Toggle Layers",
      view: mapview,
     }),
     "bottom-left"
    );

    // define widgets to add to the mapview
    mapview.ui.add(
     new Locate({
      view: mapview,
      rotationEnabled: false,
      goToLocationEnabled: true,
      goToOverride: function (view, options) {
       options.target.scale = 1500;
       return view.goTo(options.target);
      },
     }),
     "bottom-right"
    );
   }); // mapView.when
  }
 }, []); // runs once

 useEffect(() => {
  let firstRun = true;
  if (!!theMap) {
   // Observe for when a boolean property becomes true
   // Equivalent to watchUtils.whenTrue()
   reactiveUtils.when(
    () => mapView?.stationary === true,
    async () => {
     if (firstRun) {
      firstRun = false;
     } else {
      // set the store with the new extent information
      setMapExtent(mapView.extent);
     }
    }
   );
  }
 }, [theMap]);

 useEffect(() => {
  if (!!theMap) {
   if (
    !!mapView &&
    !!mapView.extent &&
    !!!mapView.extent.equals(mapExtent) &&
    !!checked
   ) {
    mapView.extent = mapExtent;
   }
  }
 }, [mapExtent, theMap]);

 // change the layer list when the resultant array changes
 useEffect(() => {
  if (mapRef.current && !!mapView && !!photoLocationsLayer) {
   mapView.when(() => {
    const layerList = new LayerList({
     // executes for each ListItem in the LayerList
     listItemCreatedFunction: async function (event) {
      // The event object contains properties of the
      // layer in the LayerList widget.
      let item = event.item; // layer-view of selection
      // Wait for the layer to load and the item title to become available
      await item.layer.when();

      if (item.layer.title === "Photo360Locations") {
       mapView.whenLayerView(item.layer).then(function (layerView) {
        photoLocationsLayerView = layerView;
       });

       item.layer.popupEnabled = true;
      } else {
       item.layer.popupEnabled = false;
      }

      // if the resultant array includes the scenario name,
      // and the resultant array's length is 1
      if (resultantArray.includes(item.title) && resultantArray.length === 1) {
       // make the item visible
       item.visible = true;
      } else {
       // set visibility of all other layers to false
       item.visible = false;
      }

      // disable popups for anything that's not a 360 photo
      if (item.title.includes("360")) {
       item.visible = true;
      }
     },
     view: mapView,
    });
   });
  }
 }, [resultantArray, theMap, photoLocationsLayerView, checked]);

 // 360 photos layer
 useEffect(() => {
  if (!!mapView && !!theMap && !!mapRef.current) {
   mapView.on("click", (event) => {
    mapView.hitTest(event).then((response) => {
     const photoUrls = response.results
      .filter((result) => result.graphic.layer.title.includes("360"))
      .map((result) => {
       let title = result.graphic.attributes.Name;
       result.graphic.layer.popupTemplate = getImage(title);
      });
    });
   });
  }
 }, [theMap, mapView]);

 return (
  <>
   <Main open={open} className="app-content-ios">
    <DrawerHeader />
    <div>
     <div className={`webmap-mobile`} ref={mapRef} />
    </div>
   </Main>
  </>
 );
};

export default CompareTwoScenariosMapContainer;
